export default class Permission {
  public id!: number
  public name!: string
}
